import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { VARIANT_COPY } from '../../config';
import { TalkToSales } from '../talk-to-sales';
import * as SX from './sx';
import type { CurrentPlanSummaryProps as Props } from './types';
import { Label } from '@aibees/shared/components';

const STAT_LABELS = [
  'Credits',
  'Seats',
  'Rollover',
  'Support',
  'Renewal',
] as const;

export const CurrentPlanSummary = memo(({ plan, className }: Props) => {
  const copy = VARIANT_COPY[plan.variant];
  const stats: Record<(typeof STAT_LABELS)[number], string> = {
    Credits: plan.credits,
    Seats: plan.seats,
    Rollover: plan.rollover,
    Support: plan.support,
    Renewal: plan.renewal,
  };

  return (
    <Box className={classnames('CurrentPlanSummary', className)} sx={SX.root}>
      <Typography variant="body2" fontWeight={700} color="grey.900">
        {copy.summaryTitle}
      </Typography>

      <Box sx={SX.priceRow}>
        <Typography variant="h4" fontWeight={700} color="grey.900">
          ${plan.price}
        </Typography>
        <Typography variant="body4" color="grey.600">
          {plan.monthLabel}
        </Typography>
      </Box>

      <Typography variant="body4" color="grey.600">
        Plan Rate
      </Typography>
      <Box sx={SX.ratePill}>
        <Label variant="soft" size="xsmall" color="primary">
          {plan.rate}
        </Label>
      </Box>

      <Box sx={SX.statsList}>
        {STAT_LABELS.map((label) => (
          <Box key={label} sx={SX.statRow}>
            <Typography variant="body4" color="grey.600">
              {label}
            </Typography>
            <Typography variant="body4" fontWeight={700} color="grey.900">
              {stats[label]}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={SX.bottomDivider} />

      <TalkToSales />
    </Box>
  );
});

CurrentPlanSummary.displayName = 'CurrentPlanSummary';
